import React from 'react';
import Navbar from '../../src/components/Navbar/Navbar';
import Footer from '../../src/components/Footer/Footer';
import TAClasses from '../../src/components/TAClasses/TAClasses';

const TAClassPage = () => {
    return (
        <div>
            <Navbar />
            <TAClasses />
            <Footer />
        </div>
    );
};

export default TAClassPage;